export const updateDeltas = (deltax, deltay) => ({
  type: "UPDATE_SWIPE_DELTAS",
  deltax,
  deltay
});
